import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer,
  createMappedRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { schema, normalize } from 'normalizr'

const normalizePresentations = data => {
  const presentation = new schema.Entity('presentations')
  return normalize(data, [presentation])
}

const SharedPresentationsReducer = combineReducers({
  fetchPresentationsRequest: createRequestReducer('SHARED_PRESENTATIONS:FETCH'),
  removePresentationRequests: createMappedRequestReducer(
    'SHARED_PRESENTATIONS:REMOVE'
  ),
  counter: createReducer(null, {
    'SHARED_PRESENTATIONS:FETCH_COUNTER_REQUEST_SUCCESS': (
      state,
      { response }
    ) => response.data.account.shared_presentations_counter,
    'SHARED_PRESENTATIONS:REMOVE_REQUEST_SUCCESS': (state, { params }) =>
      params.seen ? state : state - 1,
    'SHARED_PRESENTATIONS:MARK_AS_SEEN_REQUEST_SUCCESS': state => state - 1,
    'SHARED_PRESENTATIONS:MARK_AS_UNSEEN_REQUEST_SUCCESS': state => state + 1
  }),
  presentations: createReducer(null, {
    'SHARED_PRESENTATIONS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizePresentations(response.data.account.shared_presentations),
    'SHARED_PRESENTATIONS:REMOVE_REQUEST_SUCCESS': (state, { params }) => {
      const presentations = { ...state.entities.presentations }
      delete presentations[params.id]
      return {
        entities: { presentations },
        result: state.result.filter(id => id !== params.id)
      }
    },
    'SHARED_PRESENTATIONS:MARK_AS_SEEN_REQUEST_SUCCESS': (
      state,
      { params }
    ) => ({
      ...state,
      entities: {
        presentations: {
          ...state.entities.presentations,
          [params.id]: {
            ...state.entities.presentations[params.id],
            seen: true
          }
        }
      }
    }),
    'SHARED_PRESENTATIONS:MARK_AS_UNSEEN_REQUEST_SUCCESS': (
      state,
      { params }
    ) => ({
      ...state,
      entities: {
        presentations: {
          ...state.entities.presentations,
          [params.id]: {
            ...state.entities.presentations[params.id],
            seen: false
          }
        }
      }
    })
  })
})

export default SharedPresentationsReducer
